import * as React from "react";
const SvgFiBrandsVk = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 25 24"
    {...props}
  >
    <g clipPath="url(#fi-brands-vk_svg__a)">
      <path
        fill="#151A2D"
        d="M23.246 1.684C21.492 0 18.668 0 13.02 0h-1.042C6.332 0 3.51 0 1.754 1.684S0 6.079 0 11.5v1c0 5.421 0 8.131 1.754 9.816S6.332 24 11.98 24h1.042c5.647 0 8.47 0 10.225-1.684S25 17.921 25 12.5v-1c0-5.421 0-8.132-1.754-9.816M20.316 17h-1.823c-.695 0-.9-.532-2.136-1.719-1.082-1.001-1.545-1.131-1.815-1.131-.368 0-.477.1-.477.6v1.569c0 .43-.143.681-1.303.681-1.93 0-4.054-1.126-5.561-3.202-2.26-3.041-2.878-5.34-2.878-5.803 0-.26.104-.495.625-.495h1.824c.465 0 .64.196.816.68.891 2.493 2.395 4.672 3.013 4.672.231 0 .337-.103.337-.667V9.608c-.067-1.186-.725-1.284-.725-1.706 0-.195.175-.402.464-.402h2.866c.386 0 .52.198.52.643v3.467c0 .37.168.5.284.5.232 0 .425-.13.85-.538 1.313-1.409 2.24-3.578 2.24-3.578.117-.26.33-.495.794-.495h1.823c.551 0 .668.272.551.643-.232 1.02-2.453 4.023-2.453 4.023-.194.297-.27.445 0 .779.194.26.83.779 1.255 1.261.784.846 1.374 1.559 1.539 2.051.152.494-.11.744-.63.744"
      />
    </g>
    <defs>
      <clipPath id="fi-brands-vk_svg__a">
        <path fill="#fff" d="M0 0h25v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiBrandsVk;
